import React, {
    useState,
    useEffect,
    useRef
} from "react";
import {
    Row,
    Col,
    Button,
    Modal,
    // Image,
    Navbar,
    Nav,
    OverlayTrigger,
    Tooltip,
    Popover,
} from "react-bootstrap";
import { getFromLS, setToLS } from "../../../utils/storage";
import * as Icon from "react-bootstrap-icons";
import { pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import "../kone.css"
import { ThreeCircles, Bars } from "react-loader-spinner";
import { BlankPage } from "./BlankPage";
import { FieldPage } from "./FieldPage";
import { ReturnModal } from "../ReturnModal";
import { ApproveModal } from "./ApproveModal";
import { makeCygnusApiCall } from "../../../api/api";
import { LEGEND_DATA } from "./constants";
import { CustomButton } from "../../../reusable-components/CustomButtonComponent/button";
// Core viewer
import { Viewer } from '@react-pdf-viewer/core';


// // Import styles
import '@react-pdf-viewer/core/lib/styles/index.css';
// import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { K1ChangeHistoryModal } from "../K1ChangeHistoryModal";
import "./ComparisonFullWindowModal.css";

import { v4 } from "uuid";
import { CustomToaster } from "../../../reusable-components/Toasters/toaster";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.js`;

// css


export const ComparisonFullWindowModal = ({ onHide, ...props }) => {
    // console.log("COMPARISON FULL MODAL: ", props)
    const token = getFromLS("token");
    const [comparisonData, setComparisonData] = useState([]);
    const [file, setFile] = useState("");
    const [k1FileId, setK1FileId] = useState();
    const [pageFileLink, setPageFileLink] = useState("");
    const [templateCache, setTemplateCache] = useState({});
    const [allKonesData, setAllKonesData] = useState([]);
    const [activeKoneIndex, setActiveKoneIndex] = useState();
    const [metaData, setMetaData] = useState({});
    const [activePage, setActivePage] = useState(1);
    const [inputPage, setInputPage] = useState(activePage);
    const [templateUrls, setTemplateUrls] = useState({ "Page 1": "" });
    const [activePdfPageUrl, setActivePdfPageUrl] = useState("./TEMPLATE.pdf");
    const [k1TotalPages, setK1TotalPages] = useState(0);
    const [comparisonLoader, setComparisonLoader] = useState(true);
    const [allKoneFields, setAllKoneFields] = useState({});
    const [PAGE_FIELD_MAPPER, setPageFieldMapper] = useState({});
    const [returnModal, setReturnModal] = useState(false);
    // APPROVAL RELATED
    const [approveModal, setApproveModal] = useState(false);
    const [saveApiResponse, setSaveApiResponse] = useState();
    const [validationApiResponse, setValidationApiResponse] = useState();
    const [approveApiResponse, setApproveApiResponse] = useState();
    const [taxApiProgress, setTaxApiProgress] = useState();
    const [draftUpdateApiProgress, setDraftUpdateApiProgress] = useState()
    const [validationStatus, setValidationStatus] = useState();
    const [validationErrorFields, setValidationErrorFields] = useState();
    const [validationIssues, setValidationIssues] = useState();
    const [footnotes, setFootnotes] = useState({});
    const [editedFootnotes, setEditedFootnotes] = useState({});
    const [footnotesPages, setFootnotesPages] = useState();
    const [previewCache, setPreviewCache] = useState({ "Page 1": <div className="preview-image" /> });
    const extractedCopyRef = useRef(null);
    const [k1ChangeHistoryModalState, setK1ChangeHistoryModalState] = useState(false);
    const [showFields, setShowFields] = useState(false);
    const [onDocumentLoad, setOnDocumentLoad] = useState(false);
    let currentPage = "Page 1";

    const [dimensions, setDimensions] = useState({
        width: 0.065 * window.innerWidth,
        height: 0.178 * window.innerHeight,
    });

    const [sectionDimensions, setSectionDimensions] = useState({});

    const [activeKone, setActiveKone] = useState(
        {
            "K1FileId": undefined,
            "FirmId": "",
            "FileName": {
                "type": "button",
                "placeholder": "",
                "url": ""
            },
            "Status": "",
            "OriginalFileName": "",
            "OCRProgress": "",
            "PartnerName": "",
            "FormYear": "",
            "NumberOfPages": ''
        }
    );
    const [activeKoneData, setActiveKoneData] = useState(
        {
            "FileName": { "url": "./TEMPLATE.pdf" },
            "TemplateUrls": "./tempk1.png",
            "AfterVerified": { "Page 1": { "Checkbox Coordinates": {}, "Text Coordinates": {} } },
            "FinalEngine": { "Page 1": { "Checkbox Coordinates": {}, "Text Coordinates": {} } },
            "Metadata": {
                "Page 1": {
                    "Page 1": { "Checkbox Coordinates": {}, "Text Coordinates": {} },
                    "Page 2": { "Checkbox Coordinates": {}, "Text Coordinates": {} },
                    "Page 3": { "Checkbox Coordinates": {}, "Text Coordinates": {} },
                    "Page 4": { "Checkbox Coordinates": {}, "Text Coordinates": {} },
                    "Page 5": { "Checkbox Coordinates": {}, "Text Coordinates": {} }
                }
            },
            "K1TemplateIds": [],
            "Footnotes": { "Page 1": {} }
        });

    /** 
     * Capturing change in coomparison data dn updating state on change 
     * */
    useEffect(() => {
        setComparisonData(props.comparisondata)
    }, [props.comparisondata])

    /**
     * Based on updated comparison data set active K-1, all K-1 data, total pages, field map, preview cache
     */
    useEffect(() => {
        if (comparisonData.activekone !== undefined) {
            setActiveKone(comparisonData.activekone)
            setAllKonesData(comparisonData.apidata)
            setK1TotalPages(comparisonData.activekone.NumberOfPages)
            const preview = {}
            for (let i = 1; i < comparisonData.activekone.NumberOfPages + 1; i++) {
                Object.assign(preview, {
                    [`Page ${i}`]:
                        <div className="preview-image" style={{
                            width: dimensions.width,
                            height: dimensions.height,
                        }}>
                            <ThreeCircles
                                height={dimensions.height * 0.5}
                                width={dimensions.width * 0.5}
                                color="#fff"
                                outerCircleColor="#fff"
                                innerCircleColor="#fff"
                                middleCircleColor="#fff"
                                ariaLabel="three-circles-rotating"
                                wrapperStyle={{}}
                                wrapperClass=""
                                visible={true}
                            />
                        </div>
                })
            }
            setPreviewCache(preview)
        }
    }, [comparisonData])

    /**
     * Based on the selected K-1 update the File, Id, Link, PDF Url
     */
    useEffect(() => {
        setComparisonLoader(true)
        if (activeKone !== undefined && activeKone.K1FileId !== undefined) {
            setK1FileId(activeKone.K1FileId)
            if (activeKoneIndex === undefined) {
                setActiveKoneIndex(allKonesData.indexOf(activeKone))
            }
            console.log("ACTIVE KONE: ", activeKone["K1FileId"])
            setFile(activeKone["FileName"]["url"])            
            setPageFileLink(`${process.env.REACT_APP_BASE_URI}/workflow/k1/download/page/${localStorage.getItem("firmId")}/${activeKone["K1FileId"]}/`)
            setActivePdfPageUrl(`${process.env.REACT_APP_BASE_URI}/workflow/k1/download/page/${localStorage.getItem("firmId")}/${activeKone["K1FileId"]}/1/`)
            removeCachedPages()
        }
        else if (activeKone !== undefined && activeKone.DocumentId !== undefined) {
            setK1FileId(activeKone.DocumentId)
            if (activeKoneIndex === undefined) {
                setActiveKoneIndex(allKonesData.indexOf(activeKone))
            }
            console.log("ACTIVE KONE: ", activeKone["DocumentId"])
            setFile(activeKone["FileName"]["url"])            
            setPageFileLink(`${process.env.REACT_APP_TAX_URI}/tax/k1/download/page/${localStorage.getItem("firmId")}/${activeKone["DocumentId"]}/`)
            setActivePdfPageUrl(`${process.env.REACT_APP_TAX_URI}/tax/k1/download/page/${localStorage.getItem("firmId")}/${activeKone["DocumentId"]}/1/`)
            removeCachedPages()
        }
        setTimeout(() => {
            setComparisonLoader(false)
        }, 2500);
        setActivePage(1)
        setInputPage(1)
    }, [activeKone])

    /**
     * Whenever the File ID is changes fetch the K-1 data for the selected file
     */
    useEffect(() => {
        if (k1FileId !== undefined) {
            // console.log(comparisonData)
            if (comparisonData.activekone?.DocumentType === 'Schedule K-1') {
                getActiveKoneData(k1FileId, "pbcK1")
            }
            else {
                getActiveKoneData(k1FileId, "")
            }            
        }
        
    }, [k1FileId])

    /**
     * Update the active konme based on updated index
     */
    useEffect(() => {
        if (activeKoneIndex !== undefined) {
            // console.log("ACTIVE KONE INDEX: ", activeKoneIndex)
            setActiveKone(comparisonData.apidata[activeKoneIndex])
        }
    }, [activeKoneIndex])


    /**
     * Foototes pages are used to identify where foototes table needs to be shown
     */
    useEffect(() => {
        if (footnotes !== undefined && footnotes !== null) {
            const newSet = new Set()
            for (let [_, record] of Object.entries(footnotes)) {
                if (Object.keys(record).length > 0) {
                    for (let [_, data] of Object.entries(record)) {
                        for (let pg of data.pages) {
                            newSet.add(pg)
                        }
                    }
                }
            }
            // console.log("FOOTNOTE PAGES: ", Array.from(newSet))
            setFootnotesPages(Array.from(newSet))
        }
    }, [footnotes])

    /**
     * Set page field mapped based on footnotes and active K-1 data, footnotes pages need to show footnots tables so they need to be handled separately from regular pages
     */
    useEffect(() => {
        if (footnotesPages !== undefined && footnotes !== null) {
            if (activeKoneData !== undefined) {
                setTemplateUrls(activeKoneData["TemplateUrls"])
                setK1TotalPages(comparisonData.activekone.NumberOfPages)
                // why is settotalpages in props?
                props.settotalpages(Object.keys(activeKoneData["TemplateUrls"]).length)
                // DYNAMIC PAGE FIELD MAPPING USING BACKEND METADATA IF FRONTEND METADATA IS NOT AVAILABLE
                if (Object.keys(activeKoneData["Metadata"]).length > 0) {
                    const pageFieldMapper = {}
                    const finalenginedata = {}
                    // if its unverified, we need to use final engine data 
                    if (activeKoneData.Status === "Unverified" || activeKoneData.Status === "Ready for Review") {
                        Object.assign(finalenginedata, activeKoneData["FinalEngine"])
                        setAllKoneFields(finalenginedata)
                    }
                    // if its verified, or anything else such as draft, complete use after verified data
                    // because it changes status from unverified to verified (or anything else) after someone saves the data
                    else {
                        Object.assign(finalenginedata, activeKoneData["AfterVerified"])
                        setAllKoneFields(finalenginedata)
                    }

                    for (let [page, data] of Object.entries(activeKoneData["Metadata"])) {
                        if (Object.keys(data).length > 0) {
                            if (Object.keys(data["Page 1"]["Text Coordinates"]).length > 0) {
                                setMetaData(data)
                                Object.assign(pageFieldMapper, {
                                    [page]:
                                        <FieldPage
                                            key={v4()}
                                            metadata={data}
                                            finalenginedata={finalenginedata[page]}
                                            footnotes={editedFootnotes[page]}
                                            filelink={pageFileLink}
                                            page={page}
                                            setactivepage={(page) => setActivePage(page)}
                                            updatefields={(page, id, map, footnotes) => updateFields(page, id, map, footnotes)}
                                            sectionDimensions={sectionDimensions}
                                        />
                                })
                            } else {
                                setMetaData(data)
                                Object.assign(pageFieldMapper, {
                                    [page]:
                                        <BlankPage key={v4()} />
                                })
                            }
                        } else {
                            if (footnotesPages.includes(parseInt(page.split(" ")[1]))) {
                                if (PAGE_FIELD_MAPPER[page] && Object.entries(PAGE_FIELD_MAPPER[page].props).length > 0) {
                                    Object.assign(pageFieldMapper, { [page]: PAGE_FIELD_MAPPER[page] });
                                    continue;
                                }

                                Object.assign(pageFieldMapper, {
                                    [page]:
                                        <FieldPage
                                            key={v4()}
                                            metadata={data}
                                            finalenginedata={finalenginedata[page]}
                                            showfootnotestable={true}
                                            footnotes={editedFootnotes}
                                            footnotespages={footnotesPages}
                                            filelink={pageFileLink}
                                            page={page}
                                            setactivepage={(page) => setActivePage(page)}
                                            updatefields={(page, id, map, footnotes) => updateFields(page, id, map, footnotes)}
                                            sectionDimensions={{}}
                                        />
                                })
                            } else {
                                // console.log("PAGE: ", page)
                                // console.log("PAGE FIELD MAPPER: ", pageFieldMapper)
                                if (pageFieldMapper[page] === undefined) {
                                    Object.assign(pageFieldMapper, {
                                        [page]:
                                            <BlankPage key={v4()} />
                                    })
                                }
                            }
                        }
                        setPageFieldMapper(pageFieldMapper);
                        // console.log("PAGE FIELD MAPPER: ", PAGE_FIELD_MAPPER);
                    }
                }
            }
        }
    }, [footnotesPages, activeKoneData, sectionDimensions]);

    useEffect(() => {
        setOnDocumentLoad(false);
        const handleResize = () => {
            setDimensions({
                width: 0.065 * window.innerWidth,
                height: 0.178 * window.innerHeight,
            });

            if (extractedCopyRef.current)
                setSectionDimensions(extractedCopyRef.current.getBoundingClientRect());
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    useEffect(() => {
        if (onDocumentLoad && extractedCopyRef.current) {
            const rect = extractedCopyRef.current.getBoundingClientRect();
            if (rect.width === 0 || rect.height === 0) {
                // Delay and retry once if needed
                requestAnimationFrame(() => {
                    const retryRect = extractedCopyRef.current?.getBoundingClientRect();
                    if (retryRect?.width > 0 && retryRect?.height > 0) {
                        setSectionDimensions(retryRect);
                    }
                });
            } else {
                // Section dimensions set after PDF load
                setSectionDimensions(rect);
            }
        }
    }, [onDocumentLoad, activePage]);

    useEffect(() => {
        const handlePreviewImageClick = (page) => {
            if (currentPage !== page) {
                currentPage = page;
                setShowFields(false);
            }
        };

        if (onDocumentLoad && Object.keys(templateUrls).length > 0) {
            const temp = {};
            const preview = {};

            // Function to render preview image
            const renderPreviewImage = (page, template, overlayText, onClickHandler = null) => (
                <div className="preview-image" onClick={onClickHandler ? () => onClickHandler(page) : undefined}>
                    <img
                        src={template === "./tempk1.png" ? require("./tempk1.png") : template}
                        style={{
                            width: dimensions.width,
                            height: dimensions.height,
                            boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.25)",
                            position: "relative",
                            borderRadius: 5
                        }}
                    />
                    {overlayText && <div className="preview-overlay">{overlayText}</div>}
                </div>
            );

            for (let [page, template] of Object.entries(templateUrls)) {
                temp[page] = (
                    <img
                        src={template === "./tempk1.png" ? require("./tempk1.png") : template}
                        style={{
                            width: "100%",
                            height: "100%",
                            boxShadow: "2px 4px 8px 0px rgba(0, 0, 0, 0.25)"
                        }}
                    />
                );

                const isFootnotePage = footnotesPages.includes(parseInt(page.split(" ")[1]));
                const hasMetadata = activeKoneData["Metadata"]?.[page] && Object.keys(activeKoneData["Metadata"][page]).length > 0;

                if (isFootnotePage) {
                    preview[page] = renderPreviewImage(
                        page,
                        template,
                        template.endsWith("blank.png") ? "Footnotes" : `${page} has footnotes`,
                        () => {
                            currentPage = page;
                            setShowFields(true);
                        }
                    );
                } else if (hasMetadata) {
                    preview[page] = renderPreviewImage(page, template, page, handlePreviewImageClick);
                }
            }

            setTemplateCache(temp);
            setPreviewCache(preview);
        }
    }, [footnotesPages, templateUrls, activeKoneData, onDocumentLoad]);


    /**
     * Based on the active page update the active page pdf url to render the pdf page
     */
    useEffect(() => {
        if (pageFileLink !== "") {
            setActivePdfPageUrl(`${pageFileLink}${activePage}/`)
        }
        setInputPage(activePage)
    }, [activePage])

    /**
     * Reset functionality to reset states after modal is closed tostreamline the functionality for next action
     */
    const resetState = () => {
        // console.log("RESET STATE IS BEING CALLED!")
        setActiveKone({
            "K1FileId": undefined,
            "FirmId": "",
            "FileName": {
                "type": "button",
                "placeholder": "",
                "url": ""
            },
            "Status": "",
            "OriginalFileName": "",
            "OCRProgress": "",
            "PartnerName": "",
            "FormYear": "",
            "NumberOfPages": ''
        })
        setActiveKoneData({
            "FileName": { "url": "./TEMPLATE.pdf" },
            "TemplateUrls": "./tempk1.png",
            "AfterVerified": { "Page 1": { "Checkbox Coordinates": {}, "Text Coordinates": {} } },
            "FinalEngine": { "Page 1": { "Checkbox Coordinates": {}, "Text Coordinates": {} } },
            "Metadata": {
                "Page 1": {
                    "Page 1": { "Checkbox Coordinates": {}, "Text Coordinates": {} },
                    "Page 2": { "Checkbox Coordinates": {}, "Text Coordinates": {} },
                    "Page 3": { "Checkbox Coordinates": {}, "Text Coordinates": {} },
                    "Page 4": { "Checkbox Coordinates": {}, "Text Coordinates": {} },
                    "Page 5": { "Checkbox Coordinates": {}, "Text Coordinates": {} }
                }
            },
            "K1TemplateIds": []
        });
        setTemplateUrls({ "Page 1": "" })
        setMetaData({});
        setK1FileId(undefined)
        setActivePage(1)
        setInputPage(1)
        setValidationStatus(undefined)
        setSaveApiResponse(undefined)
        setApproveApiResponse(undefined)
        setValidationApiResponse(undefined)
        removeCachedPages()
    }

    /**
    * Reformatting and setting footnotes data for FE use
    * @param {*} ftnts : API data
    */
    const setFootnotesData = (ftnts) => {
        if (!ftnts)
            return;

        for (let [_, ftntdata] of Object.entries(ftnts)) {
            for (let datadict of Object.values(ftntdata)) {
                for (let record of datadict.data) {
                    record.push(record[0].toLowerCase().includes("total") || record[1] === "" ? false : true)
                }
            }
        }
        setFootnotes(ftnts !== undefined && ftnts !== null ? ftnts : {})
        setEditedFootnotes(ftnts !== undefined && ftnts !== null ? ftnts : {})
    }

    /**
     * Fetch and update the data for selected K-1 using the K-1 File ID
     * @param {*} fileId : K-1 ID to fetch data 
     */
    const getActiveKoneData = async (fileId, k1Source) => {
        if (fileId !== undefined) {
            let data = []
            if(k1Source === "") {
                data = await makeCygnusApiCall({
                    type: "GET",
                    payload: {},
                    url: `/k1/${fileId}/`,
                    show_message: false,
                    customized_success_message: "Got your K-1 data. Let the games begin!",
                    customized_failure_message: "Unable to fetch your K-1s data, please contact support and attach a screenshot.",
                    customized_error_message: "Error occured while getting the data for this K-1 file, please contact support and attach a screenshot.",
                    isblob: false
                })
            }
            else if (k1Source === "pbcK1") {
                data = await makeCygnusApiCall({
                    type: "GET",
                    payload: {},
                    url: `/k1/${fileId}/`,
                    show_message: false,
                    customized_success_message: "Got your PBC K-1 data. Let the games begin!",
                    customized_failure_message: "Unable to fetch your PBC K-1s data, please contact support and attach a screenshot.",
                    customized_error_message: "Error occured while getting the data for this PBC K-1 file, please contact support and attach a screenshot.",
                    isblob: false,
                    path: "/tax",
                    istax: true
                })
            }
            
            setActiveKoneData(data.data[0])
            setFootnotesData(data.data[0]["Footnotes"])
            setComparisonLoader(false)
        } else {
            CustomToaster({ type: "error", customized_message: "Unable to read the K-1 ID, please try again." })
        }
    };

    /**
     * This function is used to remove complete page wise data that is cached during comparison until the user saves the draft or approves the response
     */
    const removeCachedPages = () => {
        for (let page of Object.keys(allKoneFields)) {
            localStorage.removeItem(page)
        }
    }

    /**
     * This function is used to update the state of Fields Mapper and cache the individual page changes along with footnotes
     * @param {*} page : The active page of K-1
     * @param {*} id : Field ID that was updated
     * @param {*} map : Field map
     * @param {*} footnotes : Footnotes field map
     */
    const updateFields = (page, id, map, footnotes) => {
        if (id !== undefined) {
            setAllKoneFields(akf => (
                {
                    ...akf, [page]: {
                        "K1TemplateId": id,
                        "result": map
                    }
                }))
            setToLS(page, {
                [page]: {
                    "K1TemplateId": id,
                    "result": map
                }
            })
            setEditedFootnotes((prevFootnotes) => ({
                ...prevFootnotes,
                page: footnotes
            }));
        }
    }

    /**
     * Update the values of fields in the PREVIEW form
     * @param {*} field_id: ID of field to be updated 
     * @param {*} event: The trigger event of input in preview form
     */
    const updateDataFinal = async () => {
        setSaveApiResponse(true)
        const afterverified = {}
        for (let [page, data] of Object.entries(allKoneFields)) {
            if (Object.keys(data).length > 0) {
                Object.assign(afterverified, {
                    [page]: data
                })
            } else {
                if (activeKoneData["FinalEngine"][page] !== undefined) {
                    Object.assign(afterverified, {
                        [page]: activeKoneData["FinalEngine"][page]
                    })
                } else {
                    Object.assign(afterverified, {
                        [page]: {}
                    })
                }

            }
        }
        let payloadformat = {
            "K1FileId": activeKoneData["K1FileId"],
            "AfterVerified": afterverified,
            "Metadata": activeKoneData["Metadata"],
            "Footnotes": editedFootnotes
        }

        const data = await makeCygnusApiCall({
            type: "POST",
            payload: payloadformat,
            url: "/k1/",
            show_message: true,
            customized_success_message: "The K-1 response was saved successfully.",
            customized_failure_message: "Unable to save your K-1 response, please contact support and attach a screenshot.",
            customized_error_message: "Error occured while saving your K-1 response, please contact support and attach a screenshot.",
            isblob: false
        })
        setSaveApiResponse(false)
        if (data.success == true) {
            setValidationErrorFields(data.ValidationErrorFields)
            setValidationIssues(data.ValidationIssues)
            GetValidationStatus()
        } else {
            onHide()
            props.refresh()
        }
    }

    /**
     * Approve the response after saving
     * @param {*} field_id: ID of field to be updated 
     * @param {*} event: The trigger event of input in preview form
     */
    const GetValidationStatus = async () => {
        setValidationApiResponse(true)
        const data = await makeCygnusApiCall({
            type: "GET",
            payload: {},
            url: `/k1/validation_status/${activeKoneData["K1FileId"]}/`,
            show_message: true,
            customized_success_message: "Imported your K-1s to tax.",
            customized_failure_message: "Unable to import your K-1s to tax, please contact support and attach a screenshot.",
            customized_error_message: "Error occured while importing your K-1s to tax, please contact support and attach a screenshot.",
            isblob: false
        })
        if (data.success == true) {
            setValidationStatus(data.data[0]["ValidationStatus"] === "true" ? true : false)
            setValidationApiResponse(false)
        } else {
            setValidationApiResponse(undefined)
        }
    }

    /**
     * Approve the response after saving
     * @param {*} field_id: ID of field to be updated 
     * @param {*} event: The trigger event of input in preview form
     */
    const ApproveData = async () => {
        setApproveApiResponse(true)
        let payloadformat = {
            "K1FileId": activeKoneData["K1FileId"],
        }
        // Response is inconsequential
        const data = await makeCygnusApiCall({
            type: "POST",
            payload: payloadformat,
            url: `/k1/verify/`,
            show_message: true,
            customized_success_message: "Your K-1 response is now approved.",
            customized_failure_message: "Unable to approve your K-1 response, try again. If the problem persists, please contact support and attach a screenshot.",
            customized_error_message: "Error occured while approving your K-1 response, please contact support and attach a screenshot.",
            isblob: false
        })
        setApproveApiResponse(false)
        if (data.success == true) {
            onHide()
            props.refresh()
        }
    }

    /**
     * Send the K-1 response to TAX directly
     * @param {*} returnId : The return ID of tax to update the K-1 response, Return ID is an user input field
     */
    const SendToTax = async (returnId) => {
        setTaxApiProgress(true)
        let payloadformat
        if (returnId !== undefined) {
            payloadformat = {
                "K1FileIds": [activeKoneData["K1FileId"]],
                "ReturnId": returnId
            }
        } else {
            CustomToaster({ type: "error", customized_message: "Please enter a valid return ID.", api_message: "" })
        }
        const _ = await makeCygnusApiCall({
            type: "POST",
            payload: payloadformat,
            url: `/k1/send_to_tax/`,
            show_message: true,
            customized_success_message: "Your K-1 is now imported to tax.",
            customized_failure_message: "Unable to import your K-1 to Tax, try again. If the problem persists, please contact support and attach a screenshot.",
            customized_error_message: "Error occured while importing your K-1 to tax, please contact support and attach a screenshot.",
            isblob: false
        })
        setTaxApiProgress(false)
    }

    /**
     * Update the values of fields in the PREVIEW form
     * @param {*} field_id: ID of field to be updated 
     * @param {*} event: The trigger event of input in preview form
     */
    const updateDataDraft = async () => {
        setDraftUpdateApiProgress(true)
        const afterverified = {}
        for (let [page, data] of Object.entries(allKoneFields)) {
            if (Object.keys(data).length > 0) {
                Object.assign(afterverified, {
                    [page]: data
                })
            } else {
                if (activeKoneData["FinalEngine"][page] !== undefined) {
                    Object.assign(afterverified, {
                        [page]: activeKoneData["FinalEngine"][page]
                    })
                } else {
                    Object.assign(afterverified, {
                        [page]: {}
                    })
                }

            }
        }
        const payloadformat = {
            "K1FileId": activeKoneData["K1FileId"],
            "AfterVerified": afterverified,
            "Metadata": activeKoneData["Metadata"],
            "Footnotes": editedFootnotes
        }
        const data = await makeCygnusApiCall({
            type: "POST",
            payload: payloadformat,
            url: `/k1/draft/`,
            show_message: true,
            customized_success_message: "A draft of your K-1 response is now saved.",
            customized_failure_message: "Unable to save your K-1 response, try again. If the problem persists, please contact support and attach a screenshot.",
            customized_error_message: "Error occured while saving your K-1 response, please contact support and attach a screenshot.",
            isblob: false
        })
        setDraftUpdateApiProgress(false)
        if (data.success == true) {
            onHide()
            props.refresh()
        }
    }

    /**
     * This a navigator function to update the active K-1 page to next page
     */
    const previousPage = () => {
        if (parseInt(activePage) > 1) {
            if (parseInt(activePage) <= parseInt(k1TotalPages)) {
                setActivePage(parseInt(activePage) - 1)
            } else {
                setActivePage(1)
            }
        }
    }
    /**
     * This a navigator function to update the active K-1 page to previous page
     */
    const nextPage = () => {
        console.log("Active page: and total pages", activePage, k1TotalPages)
        if (parseInt(activePage) < parseInt(k1TotalPages)) {
            if (parseInt(activePage) >= 1) {
                setActivePage(parseInt(activePage) + 1)
            } else {
                setActivePage(parseInt(k1TotalPages))
            }
        }
    }

    useEffect(() => {
        const handleKeyDown = (e) => {
            // alert(e.key)
            if (e.key === "ArrowRight") {
                nextPage();
            }
            if (e.key === "ArrowLeft") {
                previousPage();
            }
            if (e.ctrlKey && e.key.toLowerCase() === "a") {
                e.preventDefault(); // Optional: prevent default "Select All" behavior
                setApproveModal(true);
            }
            if (e.ctrlKey && e.key.toLowerCase() === "s") {
                e.preventDefault(); // Optional: prevent default "Select All" behavior
                updateDataDraft();
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [activePage]); // You can include other dependencies if needed

    /**
     * Capture the page input field value on enter to update the active page of K-1
     * @param {*} e : On enter event 
     */
    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            // if the pressed key is Enter, do something with the value
            setActivePage(e.target.value)
        }
    };

    /**
     * This function just recalls the fetch all K-1 API for refreshing the grid content
     */
    const refreshGrid = () => {
        getActiveKoneData(k1FileId)
    }


    return (
        <>
            <ReturnModal
                show={returnModal}
                sendtotaxapiprogress={taxApiProgress}
                submit={(returnId) => SendToTax(returnId)}
                onHide={() => setReturnModal(false)}
            />
            <ApproveModal
                show={approveModal}
                submit={() => updateDataFinal()}
                approvedata={() => ApproveData()}
                validationstatus={validationStatus}
                validationerrorfields={validationErrorFields}
                validationissues={validationIssues}
                saveapiprogress={saveApiResponse}
                validationapiprogress={validationApiResponse}
                approveapiprogress={approveApiResponse}
                onHide={() => setApproveModal(false)}
            />

            {k1ChangeHistoryModalState &&
                <K1ChangeHistoryModal
                    show={k1ChangeHistoryModalState}
                    K1FileId={k1FileId}
                    FileName={activeKoneData["FileName"]["placeholder"]}
                    onHide={() => setK1ChangeHistoryModalState(false)}
                />
            }

            <Modal
                {...props}
                onHide={() => {
                    // This will close the modal
                    onHide();
                    // This will reset the state when the modal is closed
                    resetState();
                }}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                backdrop="static"
                backdropClassName="custom-backdrop"
                centered
                className="full-modal"
                scrollable="false"
            >
                <Modal.Header className="mapping-modal-header" style={{ padding: "0px " }} closeButton>
                    <Navbar collapseOnSelect expand="lg" className="sticky-nav kone-nav">
                        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
                        <Navbar.Collapse id="responsive-navbar-nav">
                            <Nav className="me-auto"></Nav>
                            <Row className="no-gutter flex-row-space-center" style={{ width: "100%" }}>
                                <Col md={4} className="flex-row-center-start pagey nav-buttons">
                                    <Icon.ChevronDoubleLeft className="k1-page-navigation-btns" style={{ margin: "0px 10px 0px 0px" }} onClick={() => setActivePage(1)} />
                                    <Icon.ChevronLeft className="k1-page-navigation-btns" style={{ margin: "0px 15px 0px 0px" }} onClick={() => previousPage()} />
                                    <div className="no-gutter flex-row-space-center">
                                        Page
                                        <input type="number"
                                            className="form-control move-left custom-input" placeholder={activePage}
                                            value={inputPage}
                                            onChange={event => setInputPage(event.target.value)}
                                            onKeyDown={event => handleKeyDown(event)}
                                            autoComplete="new-password"
                                            style={{ width: 25, padding: "0px 5px", margin: "0px 5px", MozAppearance: "textfield" }}
                                        />
                                        of {k1TotalPages}
                                    </div>
                                    <Icon.ChevronRight className="k1-page-navigation-btns" style={{ margin: "0px 0px 0px 15px" }} onClick={() => nextPage()} />
                                    <Icon.ChevronDoubleRight className="k1-page-navigation-btns" style={{ margin: "0px 0px 0px 10px" }} onClick={() => setActivePage(k1TotalPages)} />
                                </Col>
                                <Col md={4} className="flex-row-center-center pagey">
                                    <CustomButton
                                        onclick={() => setK1ChangeHistoryModalState(true)}
                                        content={"K1 Change History"}
                                        disable={activeKone === undefined && activeKone?.K1FileId === undefined}
                                    />
                                    <CustomButton
                                        progress={draftUpdateApiProgress}
                                        onclick={() => updateDataDraft()}
                                        content={draftUpdateApiProgress ? "Saving draft" : "Save draft (Ctrl+S)"}
                                        disable={false}
                                    />
                                    <CustomButton
                                        progress={approveApiResponse}
                                        onclick={() => setApproveModal(true)}
                                        content={approveApiResponse ? "Approving" : "Approve (Ctrl+A)"}
                                        disable={false}
                                    />
                                    <OverlayTrigger
                                        trigger={"click"}
                                        placement="bottom"
                                        delay={{ show: 0, hide: 100 }}
                                        overlay={
                                            <Popover id="button-tooltip">
                                                <Popover.Header as="h6">
                                                    Extracted copy data legend
                                                </Popover.Header>
                                                <Popover.Body>
                                                    <div style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'flex-start',
                                                        padding: '5px',
                                                        borderRadius: '5px',
                                                    }}>
                                                        {LEGEND_DATA.map((item, index) => (
                                                            <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '5px' }}>
                                                                <div style={{ backgroundColor: item.color, width: '20px', height: '20px', marginRight: '10px', borderRadius: '3px' }}></div>
                                                                <span style={{ fontSize: '12px', color: '#333' }}>{item.label}</span>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </Popover.Body>
                                            </Popover>
                                        }
                                        error={true}
                                    >
                                        <Icon.PatchQuestionFill style={{ fontSize: 15, color: 'var(--theme1_primary)', marginLeft: 10, cursor: "pointer" }} />
                                    </OverlayTrigger>
                                </Col>
                                <Col md={4} className="flex-row-center-end pagey">
                                    <b>{activeKoneData["FileName"]["placeholder"]}</b>
                                </Col>
                            </Row>
                        </Navbar.Collapse>
                    </Navbar>
                </Modal.Header>
                <Modal.Body className="admin-modal" style={{ paddingTop: "0px" }}>
                    <Row className='no-gutter' style={{ height: "90vh" }}>
                        <Col md={1} style={{ padding: 0, margin: 0, overflowY: "scroll", height: "98%", marginTop: "1.78%" }}>
                            {
                                Object.entries(previewCache).map(([page, img], index) =>
                                    <Row className="flex-row-center-center" style={{ margin: "5px 0px", cursor: "pointer" }} onClick={() => setActivePage(parseInt(page.split(" ")[1]))}>
                                        {img}
                                    </Row>
                                )
                            }
                        </Col>
                        <Col md={5} style={{ padding: 0, margin: "auto", height: "100%" }} >
                            <Row className='no-gutter' style={{ height: "fit-content", width: "100%" }}>
                                <Col md={12} style={{ padding: 0, margin: "auto", height: "100%" }}>
                                    {
                                        !comparisonLoader
                                            ?
                                            <h6 style={{ textAlign: 'center' }}>Original copy</h6>
                                            :
                                            null
                                    }
                                </Col>
                            </Row>
                            <Row className='no-gutter' style={{ height: "97%", width: "100%" }}>
                                <Col md={12} style={{ padding: 0, margin: "auto", height: "100%" }}>
                                    {
                                        comparisonLoader
                                            ?
                                            <div style={{ left: "40%", top: "50%", width: "fit-content", position: "relative" }}>
                                                <Bars
                                                    height="80"
                                                    width="80"
                                                    color="var(--theme1_primary)"
                                                    ariaLabel="bars-loading"
                                                    wrapperStyle={{}}
                                                    wrapperClass=""
                                                    visible={true}
                                                />
                                                <h6>Loading your page</h6>
                                            </div>
                                            :
                                            <div className="flex-row-start-center" style={{ height: "100%" }}>
                                                {
                                                    (activePdfPageUrl === "" || activePdfPageUrl) &&
                                                    <div
                                                        className="pdf-wrapper"
                                                        style={{
                                                            flex: 1,
                                                            overflow: 'hidden',
                                                            height: "100%",
                                                            width: "100%"
                                                        }}
                                                    >
                                                        <Viewer
                                                            fileUrl={activePdfPageUrl}
                                                            defaultScale={2.5}
                                                            onDocumentLoad={() => setOnDocumentLoad(true)}
                                                            httpHeaders={{
                                                                Authorization: `Bearer ${token}`,
                                                            }}
                                                        />
                                                    </div>
                                                }
                                            </div>
                                    }
                                </Col>
                            </Row>
                        </Col>
                        <Col md={5} style={{ padding: 0, margin: "auto", height: "100%" }}>
                            <Row style={{ height: "fit-content", width: "100%" }}>
                                <Col md={12} style={{ padding: 0, margin: "auto", height: "100%" }}>
                                    {
                                        !comparisonLoader
                                            ?
                                            <h6 style={{ textAlign: 'center' }}>Extracted copy</h6>
                                            :
                                            null
                                    }
                                </Col>
                            </Row>
                            <Row className='no-gutter' style={{ height: "97%", width: "100%" }}>
                                <Col md={12} style={{ padding: 0, margin: "auto", height: "100%" }}>
                                    {
                                        Object.keys(metaData).length > 0 ?
                                            <>
                                                {
                                                    comparisonLoader
                                                        ?
                                                        // this is loader
                                                        <div style={{ left: "40%", top: "50%", width: "fit-content", position: "relative" }}>
                                                            <Bars
                                                                height="80"
                                                                width="80"
                                                                color="var(--theme1_primary)"
                                                                ariaLabel="bars-loading"
                                                                wrapperStyle={{}}
                                                                wrapperClass=""
                                                                visible={true}
                                                            />
                                                            <h6>Loading your page</h6>
                                                        </div>
                                                        // end loader
                                                        :
                                                        // these are k1 inputs on right side
                                                        <div ref={extractedCopyRef} className="flex-row-start-center" style={{ height: "100%", width: "100%", objectFit: "cover" }}>
                                                            <div style={{ height: "100%", width: "100%" }}>
                                                                {
                                                                    (activePdfPageUrl === "" || activePdfPageUrl) &&
                                                                        !PAGE_FIELD_MAPPER[`Page ${activePage}`].props.showfootnotestable ? (
                                                                        <div
                                                                            className="pdf-wrapper"
                                                                            style={{
                                                                                flex: 1,
                                                                                overflow: 'hidden',
                                                                                height: "100%",
                                                                                width: "100%"
                                                                            }}
                                                                        >
                                                                            <Viewer
                                                                                fileUrl={activePdfPageUrl}
                                                                                defaultScale={2.5}
                                                                                onDocumentLoad={() =>
                                                                                    requestAnimationFrame(() => {
                                                                                        setShowFields(true);
                                                                                    })
                                                                                }
                                                                                httpHeaders={{
                                                                                    Authorization: `Bearer ${token}`,
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    ) : (
                                                                        templateCache[`Page ${activePage}`]
                                                                    )
                                                                }
                                                            </div>
                                                            {showFields &&
                                                                PAGE_FIELD_MAPPER[`Page ${activePage}`]
                                                            }
                                                        </div>
                                                }
                                            </>
                                            :
                                            <>
                                                {
                                                    Object.keys(PAGE_FIELD_MAPPER).length === 0
                                                        ?
                                                        <div style={{ left: "40%", top: "50%", width: "fit-content", position: "relative" }}>
                                                            <Bars
                                                                height="80"
                                                                width="80"
                                                                color="var(--theme1_primary)"
                                                                ariaLabel="bars-loading"
                                                                wrapperStyle={{}}
                                                                wrapperClass=""
                                                                visible={true}
                                                            />
                                                            <h6>Loading your page</h6>
                                                        </div>
                                                        :
                                                        <div className="flex-row-center-center" style={{ height: "100%" }}>Failed to load the response. Do you want to &nbsp;
                                                            <Button className="custom-button" onClick={() => refreshGrid()} >
                                                                <Icon.ArrowClockwise fill="white" className="refresh-button" /> Retry
                                                            </Button>
                                                        </div>
                                                }
                                            </>
                                    }
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    )
}